angular.module('app').controller('SchoolCtrl', function($http, $controller, $scope, $rootScope, appUtils, $route, tagService) {
    "ngInject";

    var main = this;

    main.name = 'school';
    main.defaults = {
        'tax_authorities': [],
        'contacts': [],
        'tags': []
    }

    angular.extend(main, $controller('ItemCtrl', {'$scope': $scope, 'main': main}));

    main.searchTags = tagService.search;
    main.transformChip = tagService.transformChip;
    tagService.load();

    main.load_tax_authorities = function() {
		var franchise_id = main.item.franchise_id ? main.item.franchise_id : $rootScope.franchiseSwitcher.activeFranchise()
        if(!franchise_id) {
            $scope.$on('permissions-saved', main.load_tax_authorities);
            return;
        }
        $http({
            'url': '/api/v1/admin/franchise/' + franchise_id,
            'method': 'GET'
        }).then(
            function(response) {
                main.all_tax_authorities = response.data.tax_authorities;
                if(main.id == 'new') {
                    main.all_tax_authorities.forEach(function(auth) {
                        auth.enabled = auth.default;
                    });
                } else {
                    main.all_tax_authorities.forEach(function(auth) {
                        auth.enabled = appUtils.inArray(auth, 'id', main.item.tax_authorities);
                    });
                }
            }
        );
    }

    $scope.$on('model-loaded', main.load_tax_authorities);
    $scope.$on('model-loaded', function() {
        if (!main.item.tags) main.item.tags = [];
    });
    if(main.id == 'new') {
        if($route.current.params.is_lead) {
            main.item.is_lead = true;
        }
        main.load_tax_authorities();
    }

    main.save = function() {
        if($scope.itemForm.score && $scope.itemForm.score.$invalid) {
            appUtils.toast('Please choose a score', 'error-toast');
            document.querySelector('form .ng-invalid').scrollIntoView({'behavior': 'smooth'});
            return false;
        }
        main.item.tax_authorities = angular.copy(main.all_tax_authorities).filter(function(auth) {
            var val = auth.enabled;
            delete auth.enabled;
            return val;
        });

        tagService.ensurePersisted(main.item.tags || []).then(function() {
            main._save();
        }).catch(function(error) {
            console.error('Error saving tags:', error);
            appUtils.toast('Error saving tags', 'error-toast');
        });
    }

    main.bookLead = function() {
        $http({
            'url': '/api/v1/admin/todo',
            'method': 'POST',
            'data': {
                'date_due': new Date(),
                'date_completed': new Date(),
                'action': 'Booked',
                'done': true,
                'school_id': main.item.id,
                'school': {'id': main.item.id}
            }
        })
        main.item.is_lead = false;
        main.save();
    }

    
    
    main.uncheck = function(contactId, contacts) {   
        for (var contact of contacts) {
            if (contactId == contact.id) {
                contact.is_director = true;
            } else { 
                contact.is_director = false;
            }
        }
    }
});
